// Enumerations
import { LandingOptionsMethodsEnumeration } from 'components/landing-options/enumerations/landing-options-methods.enumeration';
// Domain
const INCOME_DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.proofOfIncome.landing.modal.header.';
const IDENTIFICATION_DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.kyc.landing.modal.header.';

const LANDING_OPTIONS_MODAL_TITLES = {
  [LandingOptionsMethodsEnumeration.ACCOUNT_CHECK]: `${IDENTIFICATION_DOMAIN}accountCheckTitle`,
  [LandingOptionsMethodsEnumeration.BIZUM]: `${IDENTIFICATION_DOMAIN}bizumTitle`,
  [LandingOptionsMethodsEnumeration.OPENBANKING]: `${INCOME_DOMAIN}openBankingTitle`,
  [LandingOptionsMethodsEnumeration.TGSS]: `${INCOME_DOMAIN}TGSSTitle`,
  [LandingOptionsMethodsEnumeration.VIDEOCALL]: `${IDENTIFICATION_DOMAIN}videocallTitle`,
};

export { LANDING_OPTIONS_MODAL_TITLES };
